import { Annulation } from '../../annulation/models/Annulation';
import { AttributionFromMAPA } from '../../attribution/models/AttributionFromMAPA';
import { Initial } from '../../mapa-initial/models/Initial';
import { Rectificatif } from '../../rectificatif/models/Rectificatif';
import { TypeAdresseCompleteObligatoire } from './TypeAdresseCompleteObligatoire';

export class MAPA {

	public rectificatifFromMAPA: Rectificatif;

	public organisme: TypeAdresseCompleteObligatoire;

	public initialFromMAPA: Initial;

	public annulationFromMAPA: Annulation;

	public attributionFromMAPA: AttributionFromMAPA;

	constructor() {
		this.rectificatifFromMAPA = new Rectificatif();
		this.organisme = new TypeAdresseCompleteObligatoire();
		this.initialFromMAPA = new Initial();
		this.annulationFromMAPA = new Annulation();
		this.attributionFromMAPA = new AttributionFromMAPA();
	}
}
